<px-o120-slider [bgColor]="content.bgColor" [textColor]="content.textColor" [images]="images"></px-o120-slider>
